import { WeatherFogIcon } from './WeatherFogIcon';

/**
 * author: Austin Andrews
 * id 9E1AC9CA-0FA4-44C6-BA5D-2EB3CED4899D
 * name weather-fog
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-fog.svg
 * tags
 * - Weather 
 * - Agriculture 
 */
export const WeatherMistIcon = WeatherFogIcon;
export default WeatherMistIcon